var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2048 2048"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "green_icon",
    cx: 1024,
    cy: 1024,
    r: 1024,
    transform: "translate(190.7 190.7)",
    fill: "#79de75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-red_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2048,
    height: 2048
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "red_icon",
    clipPath: "url(#clip-red_icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-190.7 -190.7)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "red_icon-2",
    "data-name": "red_icon",
    cx: 1024,
    cy: 1024,
    r: 1024,
    transform: "translate(190.7 190.7)",
    fill: "#ea1c1c"
  })))));
};
export default __webpack_public_path__ + "static/media/red_icon.4a134f9d.svg";
export { SvgComponent as ReactComponent };